const successReducer = (state, action) => ({
  ...state,
  error: null,
  errorMessage: null,
  isLoading: false,
  successMessage: action.successMessage,
});

export default successReducer;
